/* eslint-disable prettier/prettier */
/*
  public function show_Vertragsgrundlagen()
    {
        // Inhalt
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Vertragsgrundlagen", $this->boldOptions . " fillcolor=" . $this->colors->rgb->headline);
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\n", $this->distanceOptions);
        // ...
        $copy = "\nVersicherungsantrag vom " . date("d.m.Y", time()) . "\nVertragsgrundlage sind die 4gewinnt-Versicherungsbedingungen BVG 2019 (HUS BVG 2026-08)";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy . "\n", $this->regularOptions);
        $this->dumpThisTextflow();
    }
*/
const now = new Date().toLocaleDateString("de-DE");
const vertragsgrundlagen = {
    text: [
        {
            text: "Vertragsgrundlagen\n\n", style: "subHeadOptions"
        },
        { text: "\nVersicherungsantrag vom " + now + "\nVertragsgrundlage sind die 4gewinnt-Versicherungsbedingungen BVG 2019 (HUS BVG 2026-08)", style: "regularOptions" }
    ],
    pageBreak: 'before',
    margin: [0, 20, 0, 0]
}

export { vertragsgrundlagen }